
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphEdgeGrid extends Serenity.EntityGrid<GraphEdgeRow, any> {
        protected getColumnsKey() { return 'Visualizer.GraphEdge'; }
        protected getDialogType() { return GraphEdgeDialog; }
        protected getIdProperty() { return GraphEdgeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphEdgeRow.localTextPrefix; }
        protected getService() { return GraphEdgeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}